import React from 'react';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import UIStrings from '@/Utils/UIStrings';
import ProfileGroupForm from './ProfileGroupForm';

const CompanyNameSection = () => {
    return (
        <ProfileGroupForm
            dataCy="CompanyNameSection"
            title={UIStrings.CompanyNameAsterisk}
            description={UIStrings.TheCompanyNameThatIsDisplayedToApplicants}
        >
            <div className="w-full max-w-md flex-1">
                <RHFInput id="companyName" name="companyName" type="text" fullWidth />
            </div>
        </ProfileGroupForm>
    );
};

export default CompanyNameSection;
